<div class="manage-country-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-country-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-country-shell__sidebar"
    [class.manage-country-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-country-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-country-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-country-page">
      <section class="manage-country-page__panel app-card">
        <div class="manage-country-page__panel-header">
          <div class="manage-country-page__heading-copy">
            <h2 class="app-title-serif">Manage Country Data</h2>
          </div>
        </div>

        <div class="manage-country-page__panel-body">
          <form class="manage-country-filters" [formGroup]="filterForm">
            <label class="app-form-field manage-country-filters__field">
              <span class="app-form-label">Search</span>
              <div class="manage-country-filters__search">
                <span class="manage-country-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input class="app-form-input manage-country-filters__search-input" type="text" placeholder="Search" formControlName="search" />
              </div>
            </label>

            <div class="manage-country-filters__clear">
              <button
                type="button"
                class="app-button app-button--secondary equal app-filter-actions__button"
                [disabled]="isLoading || isExporting || isSaving"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>

            <div class="manage-country-filters__actions">
              <button
                type="button"
                class="app-button app-button--secondary manage-country-filters__menu-button app-action-menu-trigger"
                [class.manage-country-filters__menu-button--open]="isCountryActionMenuOpen"
                [class.app-action-menu-trigger--open]="isCountryActionMenuOpen"
                [disabled]="isLoading || isExporting || isSaving"
                (click)="toggleCountryActionMenu()"
                aria-label="Open country data actions"
              >
                <svg class="manage-country-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true">
                  <circle cx="12" cy="5.5" r="1.5"></circle>
                  <circle cx="12" cy="12" r="1.5"></circle>
                  <circle cx="12" cy="18.5" r="1.5"></circle>
                </svg>
              </button>

              @if (isCountryActionMenuOpen) {
                <div class="manage-country-filters__menu app-action-menu-panel">
                  <button
                    type="button"
                    class="app-button app-button--secondary manage-country-filters__menu-item app-action-menu-item"
                    title="Export Data"
                    aria-label="Export Data"
                    [disabled]="isLoading || isExporting || isSaving"
                    (click)="handleExportToExcel()"
                >
                  <span class="app-action-menu-item__icon" aria-hidden="true">
                    <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                  </span>
                </button>
                </div>
              }
            </div>
          </form>

          <div class="manage-country-page__table-wrap app-table-scroll">
            <table class="manage-country-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading && !stateRows.length) {
                  <tr>
                    <td colspan="2" class="manage-country-page__empty-state">Loading country data...</td>
                  </tr>
                } @else if (visibleRows.length) {
                  @for (row of visibleRows; track trackByRow($index, row)) {
                    <tr [class]="'manage-country-table__row manage-country-table__row--' + row.level_type">
                      <td class="manage-country-table__name-cell">
                        <div class="manage-country-table__name" [style.padding-left.rem]="0.45 + row.depth * 1.4">
                          @if (hasChildren(row)) {
                            <button
                              type="button"
                              class="manage-country-table__toggle"
                              [attr.aria-expanded]="isExpanded(row)"
                              [attr.aria-label]="(isExpanded(row) ? 'Collapse' : 'Expand') + ' ' + getLevelLabel(row)"
                              (click)="toggleRow(row); $event.stopPropagation()"
                            >
                              <span aria-hidden="true">{{ isExpanded(row) ? '-' : '+' }}</span>
                            </button>
                          } @else {
                            <span class="manage-country-table__toggle manage-country-table__toggle--placeholder" aria-hidden="true"></span>
                          }

                          <div class="manage-country-table__copy">
                            <strong>{{ row.name }}</strong>
                            <span>{{ getLevelLabel(row) }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="manage-country-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open country data actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                              </summary>
                              <div class="app-row-action-menu__dropdown">
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewModal(row)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditModal(row)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>

                    @if (isLoadingRow(row) && row.level_type !== 'block') {
                      <tr class="manage-country-table__loading-row">
                        <td colspan="2" class="manage-country-page__empty-state">
                          {{ row.level_type === 'state' ? 'Loading districts...' : 'Loading block levels...' }}
                        </td>
                      </tr>
                    }
                  }
                } @else {
                  <tr>
                    <td colspan="2" class="manage-country-page__empty-state">No country data found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </main>
  </div>

  @if (editModalOpen && selectedRow) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-country-modal" open>
        <div class="manage-country-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'view' ? 'View' : 'Edit' }} {{ getLevelLabel(selectedRow) }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-country-modal__close" aria-label="Close modal" (click)="closeEditModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="editForm" (ngSubmit)="saveEdit()">
          <div class="manage-country-modal__body">
            <label class="app-form-field">
              <span class="app-form-label">Name <span class="manage-country-modal__required">*</span></span>
              <input class="app-form-input" type="text" placeholder="Enter name" formControlName="name" />
              @if (editForm.get('name')?.hasError('required') && (editForm.get('name')?.touched || formSubmitted)) {
                <section class="app-form-error">Name is required</section>
              }
            </label>
          </div>

          <div class="manage-country-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeEditModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">{{ isSaving ? 'Saving...' : 'Save' }}</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }
</div>
